import Api from '@/service/Api'


const USER_API_URL = "/api/Controllers";


class TestimonialService 
{

  get() {
    return Api().post(`${USER_API_URL}/testimonialscrud.php`, { opcion: 1 })
  }

  create(data) {
    data.opcion = 2
    return Api().post(`${USER_API_URL}/testimonialscrud.php`, data)
  }

  delete(id) {
    return Api().post(`${USER_API_URL}/testimonialscrud.php`, { opcion: 4, id: id })
  }

  update(data) {
    data.opcion = 3
    return Api().post(`${USER_API_URL}/testimonialscrud.php`, data)
  }

  getActives() {
    return Api().post(`${USER_API_URL}/testimonialscrud.php`, { opcion: 1 })
  }

}

export default new TestimonialService();
